// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"720dcb58","452":"07ae89b3","455":"f7247da2","627":"5fa19611","640":"55c243e3","653":"39fed08b","738":"eb3f4276","828":"7226fdf3","923":"0705cca5"}[chunkId] + ".chunk.js";
};